import { render, staticRenderFns } from "./TrabalhadorForm.vue?vue&type=template&id=688a176a"
import script from "./TrabalhadorForm.vue?vue&type=script&lang=js"
export * from "./TrabalhadorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports